module.exports = __webpack_public_path__ + "static/blog-header-9ff79d2c99c2b2e9f2a9b1fa266cff3c.jpg";